import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56425707"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "step__basic"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Выберите доверенность из списка", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Номер доверенности", -1))
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Дата выдачи", -1))
const _hoisted_8 = ["max"]
const _hoisted_9 = {
  key: 3,
  style: {"width":"230px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите доверенное лицо", -1))
const _hoisted_11 = { key: 4 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Файл должен быть в формате pdf", -1))
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { class: "name_power" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.subpage == 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.proxy_title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.proxy_title) = $event)),
            editable: "",
            options: _ctx.document.proxy_options,
            optionLabel: "name",
            placeholder: _ctx.proxy_default.name,
            style: {"width":"480px"},
            onChange: _ctx.proxy_change
          }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
          (_ctx.document.proxy_id>1)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: {"cursor":"pointer","display":"block","margin-left":"394px","margin-top":"-18px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open_doc(_ctx.document.proxy_id)))
              }, " Редактировать "))
            : _createCommentVNode("", true),
          (_ctx.document.proxy_id == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Введите номер доверенности",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.proxy_number) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.document.proxy_number]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.document.proxy_id == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  type: "date",
                  placeholder: "__.__.____",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.proxy_date) = $event)),
                  maxlength: "10",
                  onkeypress: "return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46",
                  max: _ctx.currentDay
                }, null, 8, _hoisted_8), [
                  [_vModelText, _ctx.document.proxy_date]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.document.proxy_id == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.signatory1_name_title,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signatory1_name_title) = $event)),
                  editable: "",
                  options: _ctx.signatory_name_options,
                  optionLabel: "name",
                  placeholder: _ctx.signatory_name_default.name,
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.signatory_name_change($event))),
                  style: {"width":"480px"}
                }, null, 8, ["modelValue", "options", "placeholder"]),
                (_ctx.document.proxy_person>1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: {"cursor":"pointer","display":"block","margin-left":"394px","margin-top":"0px","width":"100px"},
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.open_sign(_ctx.document.proxy_person)))
                    }, " Редактировать "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            ref: "proxy_file",
            type: "file",
            accept: ".pdf",
            hidden: "",
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitFile('proxy_file')))
          }, null, 544),
          (_ctx.document.proxy_id == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "btn_upload",
                  style: {"width":"480px"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$refs.proxy_file.click()))
                }, "Загрузить файл доверенности"),
                _hoisted_12
              ]))
            : _createCommentVNode("", true),
          (_ctx.document.proxy_id == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.document.proxy_file.split('/')[_ctx.document.proxy_file.split('/').length-1] == "" ? 'не загружен' : _ctx.document.proxy_file.split('/')[_ctx.document.proxy_file.split('/').length-1]), 1),
                _createElementVNode("span", {
                  class: "download_power",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=power', _ctx.document.proxy_file.split('/')[_ctx.document.proxy_file.split('/').length-1]);})
                }, "Скачать"),
                _createElementVNode("span", {
                  class: "del_power",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submitFile('proxy_file', '1')))
                }, _hoisted_16)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}